import React from 'react'
import { Suspense } from 'react'
const loading = () => <div className=""></div>;
const DefaultLayout = ({children}) => {
  return (
    <Suspense fallback={loading()}>{children}</Suspense>
  )
}

export default DefaultLayout